$(function() {

	// mask phone
	$('.phone').mask("+7 (999) 999-99-99",{placeholder:"_"});

	// header modificate
	$(window).scroll(function() {
		if ( !this.hasClass('.fixhide') ) {
			if ( this.pageYOffset > 0 ) {
				$('.header-fix').slideDown(200);
			} else {
				$('.header-fix').slideUp(200);
			}
		};
	}).trigger('scroll');

	// mobile menu
	$('.openmenu').on('click', function() {
		$('.header-side-nav-popup').slideDown(200);
		$('html').addClass('gmactive');
		$('.body-overlay').fadeIn(200);
		return false;
	});
	$('.header-side-nav-close').on('click', function() {
		$('.header-side-nav-popup').slideUp(200);
		$('html').removeClass('gmactive');
		$('.body-overlay').fadeOut(200);
		return false;
	});

	// header slider
	if ( $('.header-sl').length ) {
		var SlHeaderSl = new Swiper('.header-sl', {
			loop: false,
			speed: 1000,
			slidesPerGroup: 1,
			slidesPerView: 1,
			spaceBetween: 0,
			effect: 'flip',
			flipEffect: {
				rotate: 0,
				slideShadows: false,
			},
			autoplay: {
				delay: 3000,
				disableOnInteraction: false
			}
		});
	};

	// animate welcome block
	if ( $('.welcome').length ) {
		var _window = $(window),
			_container = $('.welcome-wrapper'),
			_content = $('.container'),
			_banner = $('.welcome'),
			winWidth = _window.width(),
			contentWidth = _content.outerWidth(),
			bannerWidth = _banner.outerWidth(),
			range = (bannerWidth - contentWidth) / 2,
			intervalId,
			oldPos = winWidth / 2,
			newPos = winWidth / 2,
			cursorPos = 0,
			bannerPos = 0;

		if ( $(window).width() > 767 ) {

			_container.on('mouseenter', function() {
				winWidth = $(window).width();
				contentWidth = _content.outerWidth();
				bannerWidth = _banner.outerWidth();
				range = (bannerWidth - contentWidth) / 2;

				_banner.stop(1, 1);
				intervalId = setInterval(followMouse, 50);

				_window.on('mousemove', function(e) {
					newPos = e.pageX;
				});
			});

			_container.on('mouseleave', function() {
				newPos = oldPos = winWidth / 2;
				_banner.animate({marginLeft: 0}, 1000);
				_window.off('mousemove');
				clearInterval(intervalId);
			});

			function followMouse() {
				var dist = newPos - oldPos;

				oldPos += dist/5;
				cursorPos = 2 * Math.round(oldPos / winWidth * 1e4) / 1e4;
				bannerPos = range - range * cursorPos;

				if (cursorPos > 100) {
					bannerPos /= -2;
				}

				_banner.css({marginLeft: bannerPos});
			};
		};
	};

	// city
	var city = [
		"Москва",
		"Можайск",
		"Мончегорск",
		"Морозовск",
		"Минск",
		"Астрахань",
		"Курск",
		"Краснодар"
	];
	$('#input-city').autocomplete({
		lookup: city,
		onSelect: function (suggestion) {
			// alert('You selected: ' + suggestion.value + ', ' + suggestion.data);
		}
	});

	animategroups();

	$('.chat').on('click', '.adduserchat_btn', function () {
		var _chat = $(this).parents('.chat-item'),
			_chat_footer = $(this).parents('.chat-foot'),
			_chat_scroll = $(this).parents('.chat-scroll');

		if ( !$(this).hasClass('mbtn-send') ) {
			var _usertext = $(this).text();
			console.log('текст кнопки' + _usertext);
		} else {
			var _usertext = _chat_footer.find('.form-control').val();
			console.log('текст поля' + _usertext);
		};

		add_user_chat(_chat, _usertext, _chat_footer);

		_chat.after( $( $(this).data('next') ).html() );
		animategroups();
		_chat_footer.html("");
	});

	$('.chat').on('input', '.form-control', function() {
		var _chat_footer = $(this).parents('.chat-foot');

		if ( $(this).val() !== '' || $(this).attr('type') == 'date' ) {
			_chat_footer.find('.mbtn-send').removeClass('mbtn-disabled');
			console.log('user_YEP');
		} else {
			_chat_footer.find('.mbtn-send').addClass('mbtn-disabled');
			console.log('user_NO');
		};
	});

	$('.chat').on('blur', '.form-control', function() {
		var _chat_footer = $(this).parents('.chat-foot');

		if ( $(this).val() !== '' || $(this).attr('type') == 'date' ) {
			_chat_footer.find('.mbtn-send').removeClass('mbtn-disabled');
			console.log('user_YEP');
		} else {
			_chat_footer.find('.mbtn-send').addClass('mbtn-disabled');
			console.log('user_NO');
		};
	});

});

function add_user_chat(_chat, _usertext, _chat_footer) {
	_chat.append( '<!-- st-->' +
		'            <div class="chat-item">' +
		'              <div class="chat-container">' +
		'                <!-- el-->' +
		'                <div class="chat-group user">' +
		'                  <div class="chat-group-content">' +
		'                    <div class="chat-group-text">' + _usertext + '</div>' +
		'                  </div>' +
		'                </div>' +
		'                <!-- /el-->' +
		'              </div>' +
		'            </div>' +
		'            <!-- /st-->' );

	_chat_footer.hide(0);
};

function add_texterror(_chat, _texterror) {
	_chat.append( '<!-- st-->' +
		'            <div class="chat-item">' +
		'              <div class="chat-container">' +
		'                <!-- el-->' +
		'                <div class="chat-group manager">' +
		'                  <div class="chat-group-content">' +
		'                    <div class="chat-group-text error">' + _texterror + '</div>' +
		'                  </div>' +
		'                </div>' +
		'                <!-- /el-->' +
		'              </div>' +
		'            </div>' +
		'            <!-- /st-->' );
};

function animategroups() {
	var mainGroup = $('.chat-nbody > .chat-item:last-child');
	var allGroup = $('.chat-nbody > .chat-item');
	var count = mainGroup.find('.chat-group-content > div:not(.history)').length;
	// var _chatscroll = $(this).parents('.chat-scroll');
	//allGroup.find(".chat-foot").hide();

	mainGroup.find('.chat-group-content > div:not(.history)').each(function (i) {
		var _group = $(this);

		console.log('yep');

		setTimeout(function() {
			_group.slideDown(500);

			if (_group.hasClass('dotts-wrapper') ) {
				_group.delay(1400).slideUp(0);
			}

			// Если это последний элемент в цикле, то показываем FOOT - кнопки
			if (count == (i + 1)) {
				mainGroup.find(".chat-foot").delay(2000).slideDown(500);
			}
		},2000 * (i + 1));
		_group.addClass("history");

		// _chatscroll.stop().animate({
		// 	scrollTop: _chatscroll[0].scrollHeight
		// }, 800);
	});
};